import _extends from 'babel-runtime/helpers/extends';
import { types } from './actions';

var initialState = {
  visible: false,
  message: null,
  status: 'default' /* success, error, default */
  , showLogo: false,
  actionLabel: null,
  actionCallback: null,
  showClose: false
};

var snackbarReducer = function snackbarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case types.SHOW_SNACKBAR:
      return _extends({}, state, {
        visible: true
      }, action.payload);

    case types.HIDE_SNACKBAR:
      return _extends({}, state, {
        visible: false
      });

    default:
      break;
  }
  return state;
};

export default snackbarReducer;
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Snackbar/reducer.js
// module id = 1066
// module chunks = 0